import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import Markdown from 'markdown-to-jsx';
import FooterColumn from './FooterColumn/FooterColumn';
import {ReactComponent as FooterLogo} from '../../../images/FooterLogo.svg';
import {ReactComponent as TwitterIcon} from '../../../images/icons/social/twitter.svg';
import {ReactComponent as LinkedInIcon} from '../../../images/icons/social/linkedIn.svg';
import {getMenuLinks, getInTouchLinks, getLegalLinks} from './FooterLinks';
import Paragraph, {FontSize} from '../Text/Paragraph/Paragraph';

import './Footer.scss';
import DynamicLink from '../../DynamicLink/DynamicLink';

function Footer(): ReactElement {
  const {formatMessage} = useIntl();
  return (
    <div className="footer">
      <div className="footer__container">
        <div className="footer__columnContainer">
          <div className="footer__columnContainer__column">
            <FooterLogo title={formatMessage({id: 'footer.column.image.alt'})} />
          </div>
          <div className="footer__columnContainer__column">
            <FooterColumn
              links={getMenuLinks(formatMessage)}
              columnTitle={formatMessage({id: 'footer.column.menu.header'})}
            />
          </div>
          <div className="footer__columnContainer__column">
            <FooterColumn
              links={getLegalLinks(formatMessage)}
              columnTitle={formatMessage({id: 'footer.column.legal.header'})}
            />
          </div>
          <div className="footer__columnContainer__column">
            <FooterColumn
              links={getInTouchLinks(formatMessage)}
              columnTitle={formatMessage({id: 'footer.column.getInTouch.header'})}
            />
            <DynamicLink
              href={formatMessage({id: 'footer.getInTouch.linkedIn.href'})}
              className="footer__columnContainer__column__socialIcons unstyledLink"
            >
              <LinkedInIcon title={formatMessage({id: 'footer.getInTouch.linkedIn.alt'})} />
            </DynamicLink>
            <DynamicLink
              href={formatMessage({id: 'footer.getInTouch.twitter.href'})}
              className="footer__columnContainer__column__socialIcons unstyledLink"
            >
              <TwitterIcon title={formatMessage({id: 'footer.getInTouch.twitter.alt'})} />
            </DynamicLink>
          </div>
        </div>
        <div className="footer__disclaimerContainer">
          <Paragraph fontSize={FontSize.SMALL}>
            <Markdown>{formatMessage({id: 'footer.column.paragraph.disclaimer'})}</Markdown>
          </Paragraph>
        </div>
      </div>
    </div>
  );
}

export default Footer;
